/**
 * Minimal React SDK for CDN
 * 
 * This is a slim bundle for use with TagadaStudio's esbuild mode.
 * Only includes essential hooks needed for checkout pages.
 * 
 * Full SDK is much larger due to TanStack Query, ISO data, etc.
 * This minimal version keeps the bundle small (~100KB vs ~9MB).
 */

// Provider (essential)
export { TagadaProvider, useTagadaContext } from './react/providers/TagadaProvider';

// Core checkout hooks (essential for commerce)
export { useCheckoutQuery as useCheckout } from './react/hooks/useCheckoutQuery';
export { useShippingRatesQuery as useShippingRates } from './react/hooks/useShippingRatesQuery';
export { useDiscountsQuery as useDiscounts } from './react/hooks/useDiscountsQuery';
export { useOrderBumpQuery as useOrderBump } from './react/hooks/useOrderBumpQuery';
export { useOrderQuery as useOrder } from './react/hooks/useOrderQuery';
export { usePostPurchasesQuery as usePostPurchases } from './react/hooks/usePostPurchasesQuery';
export { usePaymentQuery as usePayment } from './react/hooks/usePaymentQuery';
export { useThreeds } from './react/hooks/useThreeds';

// Utility hooks (commonly used)
export { useCurrency } from './react/hooks/useCurrency';
export { usePluginConfig } from './react/hooks/usePluginConfig';
export { useFunnel } from './react/hooks/useFunnel';

// Essential utilities
export { formatMoney } from './core/utils/currency';

// Re-export types that might be needed
export type { FunnelContextValue } from './react/hooks/useFunnel';
